/* ================================================== */
/* FIXED → main title
/* ================================================== */

$(document).ready(function() {

	$(window).scroll(function(e) {
		var scrollPos = $(window).scrollTop();

		// main-title
		if (scrollPos >= 110 && !$('.main-title.fixed').is('.visible')) $('.main-title.fixed').addClass('visible');
		else if (scrollPos < 110 && $('.main-title.fixed').is('.visible')) $('.main-title.fixed').removeClass('visible');
	});

	$(window).scroll();

});